"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.PaymentsContextProvider = exports.PaymentsContext = exports.getTrial = exports.getSubscription = exports.generateSubscription = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var trello_1 = require("@powerupsclub/trello");
var moment_1 = __importDefault(require("moment"));
var noop = function () {
    throw new Error('Not Implemented.');
};
var SERVER_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:3001';
var generateSubscription = function (token, powerUp, type, frequency) { return __awaiter(void 0, void 0, void 0, function () {
    var response, subscription;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("".concat(SERVER_URL, "/payments/generate-subscription"), {
                    method: 'post',
                    body: JSON.stringify({ token: token, powerUp: powerUp, type: type, frequency: frequency }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.json()];
            case 2:
                subscription = _a.sent();
                return [2 /*return*/, subscription];
            case 3: throw new Error("Failed with status code: ".concat(response.status));
        }
    });
}); };
exports.generateSubscription = generateSubscription;
var getSubscription = function (powerUp, jwt, idOrg) { return __awaiter(void 0, void 0, void 0, function () {
    var response, subscription;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("".concat(SERVER_URL, "/payments/subscription"), {
                    method: 'post',
                    body: JSON.stringify({ powerUp: powerUp, jwt: jwt, idOrg: idOrg }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.json()];
            case 2:
                subscription = _a.sent();
                return [2 /*return*/, subscription];
            case 3: throw new Error("Failed with status code: ".concat(response.status));
        }
    });
}); };
exports.getSubscription = getSubscription;
var getTrial = function (jwt, powerUp) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("".concat(SERVER_URL, "/trials/jwt"), {
                    method: 'post',
                    body: JSON.stringify({ jwt: jwt, powerUp: powerUp }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })];
            case 1:
                response = _a.sent();
                if (response.ok) {
                    return [2 /*return*/, response.json()];
                }
                else {
                    throw new Error("Failed with status code: ".concat(response.status));
                }
                return [2 /*return*/];
        }
    });
}); };
exports.getTrial = getTrial;
exports.PaymentsContext = (0, react_1.createContext)({
    isLoading: true,
    subscription: null,
    trialEndDate: null,
    refetchSubscription: noop,
    shouldShowPaymentModal: false,
    dismissPaymentModal: noop,
    shouldShowCountdown: false,
    createSubscription: noop,
    createWorkspaceSubscription: noop,
    cancelSubscription: noop,
    makePortalSession: noop
});
var PaymentsContextProvider = function (_a) {
    var children = _a.children;
    var _b = (0, react_1.useContext)(trello_1.TrelloPowerUpContext), powerUpKey = _b.powerUpKey, trelloIframe = _b.trelloIframe, isAuthorized = _b.isAuthorized, token = _b.token, board = _b.board;
    var _c = (0, react_1.useState)(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = (0, react_1.useState)(null), subscription = _d[0], setSubscription = _d[1];
    var _e = (0, react_1.useState)(null), trialEndDate = _e[0], setTrialEndDate = _e[1];
    var _f = (0, react_1.useState)(false), hasDismissedPayment = _f[0], setHasDismissedPayment = _f[1];
    var shouldShowCountdown = (0, react_1.useMemo)(function () {
        if (!trialEndDate || !subscription) {
            return false;
        }
        var trialHasEnded = trialEndDate ? new Date() > trialEndDate : false;
        var notSubscribed = (subscription === null || subscription === void 0 ? void 0 : subscription.status) !== 'active';
        return !trialHasEnded && notSubscribed && (0, moment_1["default"])(trialEndDate).isValid();
    }, [isAuthorized, trialEndDate, hasDismissedPayment, subscription]);
    var shouldShowPaymentModal = (0, react_1.useMemo)(function () {
        var _a, _b;
        if (subscription === null || subscription === void 0 ? void 0 : subscription.hasByPass) {
            return false;
        }
        var trialHasEnded = trialEndDate ? new Date() > trialEndDate : false;
        var notSubscribed = (subscription === null || subscription === void 0 ? void 0 : subscription.status) !== 'active';
        if (!trialEndDate) {
            return false;
        }
        if (notSubscribed) {
            if ((_a = subscription === null || subscription === void 0 ? void 0 : subscription.currentPeriodEnd) === null || _a === void 0 ? void 0 : _a.individual) {
                var date = new Date(subscription.currentPeriodEnd.individual * 1000);
                if (new Date() < date) {
                    return false;
                }
            }
            if ((_b = subscription === null || subscription === void 0 ? void 0 : subscription.currentPeriodEnd) === null || _b === void 0 ? void 0 : _b.workspace) {
                var date = new Date(subscription.currentPeriodEnd.workspace * 1000);
                if (new Date() < date) {
                    return false;
                }
            }
        }
        return ((trialHasEnded && notSubscribed) ||
            (notSubscribed && !hasDismissedPayment));
    }, [isAuthorized, trialEndDate, hasDismissedPayment, subscription]);
    var dismissPaymentModal = function () {
        setHasDismissedPayment(true);
    };
    var refetchSubscription = function (opts) { return __awaiter(void 0, void 0, void 0, function () {
        var jwt, sub, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, trelloIframe.jwt({
                        state: JSON.stringify({ token: token })
                    })];
                case 1:
                    jwt = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, (0, exports.getSubscription)(powerUpKey, jwt, board.idOrganization)];
                case 3:
                    sub = _a.sent();
                    setSubscription(sub);
                    return [4 /*yield*/, trelloIframe.set('board', 'private', 'subscription', sub)];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 6];
                case 6:
                    if (opts === null || opts === void 0 ? void 0 : opts.waitForStatus) {
                        if ((sub === null || sub === void 0 ? void 0 : sub.status) !== opts.waitForStatus) {
                            return [2 /*return*/, refetchSubscription(opts)];
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var createSubscription = function (type, frequency) {
        return (0, exports.generateSubscription)(token, powerUpKey, type, frequency);
    };
    var createWorkspaceSubscription = function (idOrg, paymentMethodId, seats) { return __awaiter(void 0, void 0, void 0, function () {
        var response, subscription_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("".concat(SERVER_URL, "/payments/create-workspace-subscription"), {
                        method: 'post',
                        body: JSON.stringify({
                            token: token,
                            powerUp: powerUpKey,
                            idOrg: idOrg,
                            paymentMethodId: paymentMethodId,
                            seats: seats
                        }),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    subscription_1 = _a.sent();
                    return [2 /*return*/, subscription_1];
                case 3: throw new Error("Failed with status code: ".concat(response.status));
            }
        });
    }); };
    var cancelSubscription = function (type, idOrg) { return __awaiter(void 0, void 0, void 0, function () {
        var jwt, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, trelloIframe.jwt({
                        state: JSON.stringify({ token: token })
                    })];
                case 1:
                    jwt = _a.sent();
                    return [4 /*yield*/, fetch("".concat(SERVER_URL, "/payments/cancel-subscription"), {
                            method: 'post',
                            body: JSON.stringify({
                                jwt: jwt,
                                powerUp: powerUpKey,
                                type: type,
                                idOrg: idOrg
                            }),
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })];
                case 2:
                    response = _a.sent();
                    if (response.ok) {
                        refetchSubscription();
                        return [2 /*return*/, true];
                    }
                    else {
                        throw new Error("Failed with status code: ".concat(response.status));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var makePortalSession = function () { return __awaiter(void 0, void 0, void 0, function () {
        var jwt, response, session;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, trelloIframe.jwt({
                        state: JSON.stringify({ token: token })
                    })];
                case 1:
                    jwt = _a.sent();
                    return [4 /*yield*/, fetch("".concat(SERVER_URL, "/v2/payments/portal-sesion"), {
                            method: 'post',
                            body: JSON.stringify({
                                jwt: jwt,
                                powerUpKey: powerUpKey
                            }),
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 3:
                    session = _a.sent();
                    return [2 /*return*/, session];
                case 4: throw new Error("Failed with status code: ".concat(response.status));
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        var initSub = function () { return __awaiter(void 0, void 0, void 0, function () {
            var jwt, _trial;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsLoading(true);
                        return [4 /*yield*/, trelloIframe.jwt({ state: JSON.stringify({ token: token }) })];
                    case 1:
                        jwt = _a.sent();
                        return [4 /*yield*/, (0, exports.getTrial)(jwt, powerUpKey)];
                    case 2:
                        _trial = _a.sent();
                        return [4 /*yield*/, refetchSubscription()];
                    case 3:
                        _a.sent();
                        setTrialEndDate(new Date(_trial.trialEnds));
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        if (isAuthorized && token) {
            initSub();
        }
    }, [isAuthorized, token]);
    return ((0, jsx_runtime_1.jsx)(exports.PaymentsContext.Provider, __assign({ value: {
            isLoading: isLoading,
            subscription: subscription,
            trialEndDate: trialEndDate,
            refetchSubscription: refetchSubscription,
            shouldShowPaymentModal: shouldShowPaymentModal,
            dismissPaymentModal: dismissPaymentModal,
            shouldShowCountdown: shouldShowCountdown,
            createSubscription: createSubscription,
            createWorkspaceSubscription: createWorkspaceSubscription,
            cancelSubscription: cancelSubscription,
            makePortalSession: makePortalSession
        } }, { children: children }), void 0));
};
exports.PaymentsContextProvider = PaymentsContextProvider;
//# sourceMappingURL=PaymentsContext.js.map